import React, { useRef, useState, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'
import { gsap, ScrollSmoother } from 'gsap-wrapper'
import ThemeProvider from 'styles/theme-provider'
import CookiesBanner from 'components/ui-elements/cookies-banner'

import 'styles/fonts.css'
import GlobalStyle from 'styles/global-styles'
import {
  LayoutWrapper,
  PageWrapper,
  ContentWrapper
} from './index.styled'

import LayoutPasswordRequest from './password-request'

const LayoutContent = ({ children, location }) => {
  return (
    <TransitionGroup component={null}>
      <Transition key={location.pathname} timeout={{ enter: 1000, exit: 1000 }}>
        {(status) => (
          <div className={`page ${status}`}>
            <LayoutWrapper>{children}</LayoutWrapper>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = ({ children, location, pageContext: { password } }) => {
  const refWrapper = useRef(null)
  const scrollSmoother = useRef(null)
  const [allowedAccess, setAllowedAccess] = useState(!password)

  useLayoutEffect(() => {
    if (!allowedAccess) {
      return
    }
    const gsapContext = gsap.context(() => {
      scrollSmoother.current = ScrollSmoother.create({
        content: '.home-content',
        wrapper: '.home-wrapper',
        smooth: 2,
        effects: true
        // normalizeScroll: true,
      })
    }, [refWrapper])

    return () => gsapContext.revert()
  }, [children, allowedAccess])

  return (
    <ThemeProvider location={location} scrollSmoother={scrollSmoother}>
      <GlobalStyle />
      {allowedAccess
        ? (
          <div className='home-wrapper' ref={refWrapper}>
            <CookiesBanner />
            <div className='home-content'>
              <PageWrapper>
                <ContentWrapper>
                  <LayoutContent location={location}>{children}</LayoutContent>
                </ContentWrapper>
              </PageWrapper>
            </div>
          </div>
          )
        : (
          <LayoutPasswordRequest password={password} onLoginSuccess={() => setAllowedAccess(true)} />
          )}
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired
}

export default Layout
